<template>
  <vue-dialog :dialog-data="dialogData" @confirm="confirm">
    <el-form :model="form" label-width="auto" :rules="rules" ref="form" size="small">
      <el-form-item label="厂商" prop="company_id">
        <company-select v-model="form.company_id" clearable/>
      </el-form-item>
      <el-form-item label="开始MAC" prop="start_mac">
        <el-input v-model.trim="form.start_mac" clearable placeholder="手动输入或粘贴"></el-input>
      </el-form-item>
      <el-form-item label="结束MAC" prop="end_mac">
        <el-input v-model.trim="form.end_mac" clearable placeholder="手动输入或粘贴"></el-input>
      </el-form-item>
    </el-form>
  </vue-dialog>
</template>

<script>
  import {inputEmpty,changeEmpty,checkMac} from '@utils/validate'
  import CompanySelect from "@view/components/select/CompanySelect"
  export default {
    name: "MacOperate",
    props: {dialogData: Object},
    components: {CompanySelect},
    data() {
      return {
        form: {
          company_id: "",
          start_mac: "",
          end_mac: "",
        },
        rules: {
          company_id: [changeEmpty('厂商')],
          start_mac: [inputEmpty('开始MAC'),checkMac()],
          end_mac: [inputEmpty('结束MAC'),checkMac()],
        },
      }
    },
    methods: {
      confirm() {
        this.$refs["form"].validate(async isOk => {
          if (isOk) {
            let nv = {};
            this.copyObjValue(nv, this.form);
            let res = await this.$Http.addCompanyMac(nv);
            if (res) {
              this.msgSuccess("添加成功");
              this.$emit("table-reload");
              this.dialogData.visible = false;
            }
          }
        });
      },
    }
  }
</script>

<style scoped>

</style>
